module.exports = __webpack_public_path__ + "static/media/indentplanner_old.9a91170d.png";